import { isUndefined } from 'lodash'
import mitt from 'mitt'

import { uid } from '@/utils/uid'

export const notifyBus = mitt()

export const NOTIFICATION_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning'
}

export const NOTIFICATION_DURATIONS = {
  SHORT: 'short',
  MEDIUM: 'medium',
  LONG: 'long',
  INFINITE: 'infinite'
}

/**
 * @param {object} [options]
 * @param {string} [options.title]
 * @param {string} [options.content]
 * @param {string} [options.type] one of NOTIFICATION_TYPES
 * @param {boolean} [options.isHtml]
 * @param {string} [options.duration] one of NOTIFICATION_DURATIONS
 * @param {boolean} [options.expandable]
 * @param {boolean} [options.expanded]
 * @param {string} [options.btnText]
 * @param {string} [options.btnIcon]
 * @param {Function|null} [options.onBtnClick]
 * @param {boolean} [options.hideOnBtnClick]
 * @param {boolean} [options.withVerticalDivider]
 * @param {boolean} [options.withButtonClose]
 * @param {Array<{ id: number, label: string, closeOnHandle: boolean, handler: Function }>|null} [options.actions] buttons of the expanded notification, label is a translation key
 */
export const showNotify = ({
  title = '',
  content = '',
  type = NOTIFICATION_TYPES.SUCCESS,
  isHtml = false,
  duration = undefined,
  expandable = undefined,
  expanded = false,
  btnText = '',
  btnIcon = '',
  onBtnClick = null,
  hideOnBtnClick = false,
  withVerticalDivider = false,
  withButtonClose = undefined,
  actions = null
} = {}) => {
  let delay = duration || NOTIFICATION_DURATIONS.SHORT
  let showCloseButton = Boolean(withButtonClose)

  if (type === NOTIFICATION_TYPES.ERROR) {
    delay = isUndefined(duration) ? NOTIFICATION_DURATIONS.LONG : duration
    showCloseButton = isUndefined(withButtonClose) ? true : withButtonClose
  }

  const id = uid()
  notifyBus.emit('show-notify', {
    id,
    content,
    type,
    isHtml,
    duration,
    delay,
    title,
    expandable,
    expanded,
    btnText,
    btnIcon,
    onBtnClick,
    hideOnBtnClick,
    withVerticalDivider,
    withButtonClose: showCloseButton,
    actions
  })
}
